import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import { applyAuthTokenInterceptor, clearAuthTokens } from 'axios-jwt'
import { getIndexPageMobile } from '@/router/personalCabinet'
import { currentLocale } from '@/i18n'

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Accept-Language': currentLocale()
  }
}
const axiosInstance = axios.create(config)
axiosInstance.interceptors.request.use(request => {
  request.headers['Accept-Language'] = currentLocale()
  return request
})
const createNotify = (title, type = 'error') => {
  Vue.notify({ type, title })
}
axiosInstance.interceptors.response.use(undefined, function (err) {
  return new Promise(function () {
    const status = err.response?.status
    if (status === 500) {
      createNotify('A critical error has occurred, contact your administrator')
      throw err
    }
    if (status === 401) {
      clearAuthTokens()
      localStorage.clear()
      router.push({ name: 'login' }).catch(() => {})
    }
    if (status === 403 || status === 404) {
      createNotify('You dont have access to this page')
      const userRoles = JSON.parse(localStorage.getItem('userGroups')) || []
      router.push({ name: getIndexPageMobile(userRoles) || 'access-denied' }).catch(() => {})
    }
    for (const key in err.response.data) {
      const error = err.response.data[key]
      if (Array.isArray(error)) {
        createNotify(error[0])
      } else {
        createNotify(error)
      }
    }
    throw err
  })
})

const requestRefresh = (refresh) => {
  return new Promise((resolve, reject) => {
    axios.post(`${config.baseURL}auth/jwt/refresh/`, { refresh }).then(response => {
      resolve({
        accessToken: response.data.access,
        refreshToken: response.data.refresh
      })
    }).catch(error => {
      if (error.response.status === 401) {
        createNotify('Unauthorized', 'warning')
        router.push({ name: 'login' }).catch(() => {})
      }
      reject(error)
    })
  })
}

applyAuthTokenInterceptor(axiosInstance, { requestRefresh })

export default axiosInstance
